module.exports = __webpack_public_path__ + "static/media/rihanna.6246fb40.jpg";